(function Module() {
	'use strict';

	mySynch.factory('UtilService', [
		function utilService() {

            function callbackOrLog(callback, err, data) {
				if (_.isFunction(callback)) {
					callback(err, data);
				} else {
					if (err) {
						console.log('unhandled api response with error', {err: err});
					} else if (_.isNull(data)) {
						console.log('unhandled api response with null data', {data: data});
					} else {
						console.log('unhandled api response with data', {data: data});
					}
				}
			}






            return {		
				callbackOrLog: callbackOrLog
			};
		}
	]);
})();
